import React, { useEffect, useState } from "react";

const VisualSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll logic (puede quedarse, no rompe nada)
  const getImageStyles = () => {
    const sectionStart = 600;
    const fadeStart = sectionStart + 100;
    const fadeEnd = sectionStart + 400;

    let opacity = 0.8;
    let transform = "translateY(0px)";

    if (scrollY > fadeStart && scrollY <= fadeEnd) {
      const fadeProgress = (scrollY - fadeStart) / (fadeEnd - fadeStart);
      opacity = 0.8 * (1 - fadeProgress);
      transform = `translateY(${fadeProgress * 20}px)`;
    } else if (scrollY > fadeEnd) {
      opacity = 0;
      transform = "translateY(20px)";
    }

    return { opacity, transform };
  };

  //  no renderiza esta sección AHORA
  return null;
};

export default VisualSection;
